package com.narbase.letsgo.web.views.support

import com.narbase.kunafa.core.components.*
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.matchParent
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.dimen
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.drawable.Color
import com.narbase.kunafa.core.lifecycle.LifecycleOwner
import com.narbase.letsgo.web.common.AppColors
import com.narbase.letsgo.web.translations.localized
import com.narbase.letsgo.web.utils.horizontalFiller
import com.narbase.letsgo.web.utils.scrollable.scrollable
import com.narbase.letsgo.web.utils.table.headerCell
import com.narbase.letsgo.web.utils.table.listTable
import com.narbase.letsgo.web.utils.table.tableCell
import com.narbase.letsgo.web.utils.table.tableRow
import com.narbase.letsgo.web.utils.verticalSeparator
import com.narbase.letsgo.web.utils.views.*

class SupportManagementComponent : Component() {
    val viewModel = SupportManagementViewModel()

    private var listTableBody: View? = null

    override fun onViewMounted(lifecycleOwner: LifecycleOwner) {
        super.onViewMounted(lifecycleOwner)
        viewModel.getSupportItems()
    }

    private fun onListLoaded() {
        listTableBody?.clearAllChildren()
        listTableBody?.apply {
            viewModel.supportItemList.forEachIndexed { index, item ->
                tableRow {
                    style {
                        alignItems = Alignment.Center
                        paddingEnd = 8.px
                    }
                    tableCell(item.category.title.en, 1, 14.px)
                    tableCell(if (item.category.isActive) "Active" else "", 1, 14.px)
                    onClick = {
                        UpsertSupportItemDialog(item) {
                            viewModel.getSupportItems()
                        }.show()
                    }
                }

                if (index != viewModel.supportItemList.lastIndex) {
                    verticalSeparator()
                }
            }
        }
    }

    override fun View?.getView() = view {
        id = "ManagementRootView"
        style {
            matchParentDimensions
        }
        scrollable {
            style {
                matchParentDimensions
            }

            verticalLayout {
                style {
                    width = matchParent
                    height = wrapContent
                    padding = 32.px
                }

                horizontalLayout {
                    style {
                        width = matchParent
                    }
                    textView {
                        text = "Support Management".localized()
                        style {
                            width = wrapContent
                            fontSize = 20.px
                            fontWeight = "bold"
                        }
                    }

                    horizontalFiller()

                    addButton()

                }

                verticalLayout {
                    matchParentDimensions()
                    withLoadingAndError(viewModel.getUiState,
                        onRetryClicked = { viewModel.getSupportItems() },
                        onLoaded = { onListLoaded() })

                    listTableBody = listTable {
                        headerCell("Title".localized(), 1)
                        headerCell("".localized(), { 24.px })
                    }
                }
            }
        }
    }

    private fun LinearLayout.addButton() {
        textView {
            style {
                color = Color.white
                padding = "2px 12px".dimen()
                backgroundColor = AppColors.mainColor
                borderRadius = 12.px
                pointerCursor()
                hover {
                    backgroundColor = AppColors.mainDarkColor
                }
            }

            onClick = {
                UpsertSupportItemDialog(null) {
                    viewModel.getSupportItems()
                }.show()
            }

            id = "AddButton"
            text = "+ Add New Category".localized()
        }
    }
}